// Plain-text sanitizer for customer feedback. Mirror of
// backend/src/lib/feedbackText.ts — the client sanitizes before sending so
// only clean text ever leaves the browser, and the server re-applies the same
// pass as defense-in-depth. Keep the two copies in sync.

export const FEEDBACK_MAX_LENGTH = 2000;

export function sanitizeFeedbackText(raw: string): string {
  let text = raw.normalize('NFC');

  // Strip markup so only plain text is ever stored. Only real-looking tags —
  // "</b>", "<img …>" — are removed; prose like "5 < 10" or "<3" is left alone.
  text = text.replace(/<\/?[a-zA-Z][^>]*>/g, ' ');

  // Normalize newlines before filtering control characters.
  text = text.replace(/\r\n?/g, '\n');

  // Remove C0/C1 control chars (keep \n \t), zero-width chars, line/paragraph
  // separators, and bidi-control chars.
  text = text.replace(
    // eslint-disable-next-line no-control-regex -- stripping control chars is the point
    /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F\u200B-\u200F\u2028\u2029\u202A-\u202E\u2066-\u2069\uFEFF]/g,
    '',
  );

  // Collapse horizontal whitespace runs, trailing spaces, and 3+ blank lines.
  text = text.replace(/[ \t]{2,}/g, ' ');
  text = text.replace(/[ \t]+\n/g, '\n');
  text = text.replace(/\n{3,}/g, '\n\n');

  text = text.trim();
  if (text.length > FEEDBACK_MAX_LENGTH) {
    text = text.slice(0, FEEDBACK_MAX_LENGTH).trimEnd();
  }
  return text;
}
